<template>
    <div class="tyn-root">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="sa">
                        <section class="sa-hero">
                            <div class="sa-hero-texto">
                                <div class="sa-hero-titulos">
                                    <h1 class="sa-hero-titulo">A melhor capacitação em licitações do Brasil</h1>
                                    <p class="sa-hero-sub">Aulas com especialistas sobre licitações, contratos, pregão, governança e muito mais.</p>
                                </div>
                                <form class="sa-busca" role="search" @submit.prevent="buscar">
                                    <label class="sa-busca-campo">
                                        <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
                                        <span class="sa-sr">Buscar trilhas</span>
                                        <input v-model="termoBusca" type="search" placeholder="Buscar trilhas, temas ou instrutores" />
                                    </label>
                                    <button type="submit" class="sa-btn sa-btn--primario">Buscar</button>
                                </form>
                            </div>

                            <div class="sa-hero-atalhos">
                                <nav class="sa-atalhos" aria-label="Atalhos">
                                    <router-link to="/SollAcademyMinhasTrilhas" class="sa-atalho">
                                        <span class="sa-atalho-icone sa-atalho-icone--destaque">
                                            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M22 10 12 5 2 10l10 5 10-5Z" /><path d="M6 12v5c3 2 9 2 12 0v-5" /></svg>
                                        </span>
                                        <span class="sa-atalho-texto">
                                            <strong>Minhas trilhas</strong>
                                            <span>{{ resumo.emAndamento }} em andamento<template v-if="resumo.concluidas"> · {{ plural(resumo.concluidas, 'concluída', 'concluídas') }}</template></span>
                                        </span>
                                        <svg class="sa-atalho-seta" viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6" /></svg>
                                    </router-link>
                                    <router-link :to="{ name: 'SollAcademyTrilhas' }" class="sa-atalho">
                                        <span class="sa-atalho-icone">
                                            <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /></svg>
                                        </span>
                                        <span class="sa-atalho-texto">
                                            <strong>Todas as categorias</strong>
                                            <span>{{ plural(resumo.totalCategorias, 'categoria', 'categorias') }}<template v-if="resumo.totalTrilhas"> · {{ plural(resumo.totalTrilhas, 'trilha', 'trilhas') }}</template></span>
                                        </span>
                                        <svg class="sa-atalho-seta" viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6" /></svg>
                                    </router-link>
                                </nav>
                                <button type="button" class="sa-manual" @click="abrirManual">
                                    <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M9.5 9a2.5 2.5 0 0 1 4.9.8c0 1.7-2.4 2.2-2.4 3.7M12 17h.01" /></svg>
                                    Manual da plataforma
                                </button>
                            </div>
                        </section>

                        <main class="sa-main">
                            <section v-if="destaquePrincipal" aria-label="Trilhas em destaque" @mouseenter="pausarCarrossel" @mouseleave="retomarCarrossel">
                                <div class="sa-destaques" :class="['sa-destaques--' + destaquesVisiveis.length, direcaoCarrossel === 'voltar' ? 'is-voltar' : 'is-avancar']">
                                    <div class="sa-destaque-principal" :style="tom(destaquePrincipal)">
                                        <transition :name="direcaoCarrossel === 'voltar' ? 'sa-slide-voltar' : 'sa-slide'">
                                        <button type="button" class="sa-destaque-link" :key="destaquePrincipal.idTreinamento" @click="abrirModal(destaquePrincipal)">
                                            <img v-if="!semImagem(destaquePrincipal)"
                                                 :src="destaquePrincipal.urlFoto"
                                                 alt=""
                                                 @error="onErroImagem(destaquePrincipal)" />
                                            <span class="sa-destaque-scrim"></span>
                                            <span class="sa-destaque-conteudo">
                                                <span v-if="nomeCategoria(destaquePrincipal.idCategoria)" class="sa-selo sa-selo--azul">{{ nomeCategoria(destaquePrincipal.idCategoria) }}</span>
                                                <span class="sa-destaque-titulo">{{ destaquePrincipal.nmTreinamento }}</span>
                                                <span v-if="destaquePrincipal.dsTreinamento" class="sa-destaque-desc">{{ destaquePrincipal.dsTreinamento }}</span>
                                                <span class="sa-destaque-rodape">
                                                    <span class="sa-destaque-cta">
                                                        <svg viewBox="0 0 24 24" aria-hidden="true" class="is-fill"><path d="M7 4v16l13-8Z" /></svg>
                                                        {{ progressoDe(destaquePrincipal) > 0 ? 'Continuar trilha' : 'Começar trilha' }}
                                                    </span>
                                                </span>
                                            </span>
                                        </button>
                                        </transition>
                                        <div v-if="trilhasDestaque.length > 1" class="sa-carrossel-controles">
                                            <div class="sa-pontos" aria-hidden="true">
                                                <span v-for="(d, i) in trilhasDestaque" :key="d.idTreinamento || i" class="sa-ponto" :class="{ 'is-ativo': i === indiceDestaque }"></span>
                                            </div>
                                            <button type="button" class="sa-btn-circulo" aria-label="Destaques anteriores" @click="destaqueAnterior">
                                                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6" /></svg>
                                            </button>
                                            <button type="button" class="sa-btn-circulo" aria-label="Próximos destaques" @click="proximoDestaqueManual">
                                                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6" /></svg>
                                            </button>
                                        </div>
                                    </div>

                                    <button v-for="d in destaquesSecundarios"
                                            :key="d.idTreinamento"
                                            type="button"
                                            class="sa-card sa-destaque-sec"
                                            @click="abrirModal(d)">
                                        <span class="sa-capa" :style="tom(d)">
                                            <img v-if="!semImagem(d)" :src="d.urlFoto" alt="" @error="onErroImagem(d)" />
                                            <svg v-else class="sa-capa-icone" viewBox="0 0 24 24" aria-hidden="true"><path d="M2 4h7a3 3 0 0 1 3 3v13a2 2 0 0 0-2-2H2Z" /><path d="M22 4h-7a3 3 0 0 0-3 3v13a2 2 0 0 1 2-2h8Z" /></svg>
                                            <span v-if="nomeCategoria(d.idCategoria)" class="sa-selo sa-selo--claro">{{ nomeCategoria(d.idCategoria) }}</span>
                                        </span>
                                        <span class="sa-card-corpo">
                                            <span class="sa-card-titulo">{{ d.nmTreinamento }}</span>
                                            <span v-if="d.dsTreinamento" class="sa-card-desc">{{ d.dsTreinamento }}</span>
                                            <span v-if="d.nmAutor" class="sa-card-meta">{{ d.nmAutor }}</span>
                                        </span>
                                    </button>
                                </div>
                            </section>

                            <section v-if="trilhasRecentes.length" class="sa-secao sa-painel" aria-labelledby="sa-h-continue">
                                <div class="sa-secao-cabecalho">
                                    <h2 id="sa-h-continue" class="sa-h2">Continue de onde parou</h2>
                                    <router-link to="/SollAcademyMinhasTrilhas" class="sa-link">
                                        Minhas trilhas
                                        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6" /></svg>
                                    </router-link>
                                </div>
                                <ul class="sa-continue">
                                    <li v-for="t in trilhasRecentes" :key="'recent-' + t.idTreinamento">
                                        <button type="button" class="sa-card sa-continue-card" @click="abrirModal(t)">
                                            <span class="sa-continue-thumb" :style="tom(t)">
                                                <img v-if="!semImagem(t)" :src="t.urlFoto" alt="" @error="onErroImagem(t)" />
                                                <span class="sa-play"><svg viewBox="0 0 24 24" aria-hidden="true" class="is-fill"><path d="M7 4v16l13-8Z" /></svg></span>
                                            </span>
                                            <span class="sa-continue-texto">
                                                <span class="sa-card-titulo">{{ t.nmTreinamento }}</span>
                                                <span class="sa-barra" role="progressbar" :aria-valuenow="Math.round(progressoDe(t))" aria-valuemin="0" aria-valuemax="100">
                                                    <span class="sa-barra-fill" :style="{ width: progressoDe(t) + '%' }"></span>
                                                </span>
                                                <span class="sa-card-meta">{{ metaProgresso(t) }}</span>
                                            </span>
                                        </button>
                                    </li>
                                </ul>
                            </section>

                            <section v-for="cat in categoriasVisiveis"
                                     :key="cat.idCategoria"
                                     class="sa-secao sa-painel"
                                     :aria-labelledby="'sa-h-cat-' + cat.idCategoria">
                                <div class="sa-secao-cabecalho">
                                    <div class="sa-secao-titulos">
                                        <h2 :id="'sa-h-cat-' + cat.idCategoria" class="sa-h2">{{ cat.nmCategoria }}</h2>
                                        <span class="sa-contagem">{{ plural(cat.total, 'trilha', 'trilhas') }}</span>
                                    </div>
                                    <router-link class="sa-link" :to="{ name: 'SollAcademyTrilhas', query: { categoria: cat.idCategoria } }">
                                        Ver tudo
                                        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6" /></svg>
                                    </router-link>
                                </div>
                                <ul class="sa-trilhas">
                                    <li v-for="trilha in cat.trilhas" :key="trilha.idTreinamento">
                                        <button type="button" class="sa-card sa-trilha" @click="abrirModal(trilha)">
                                            <span class="sa-capa" :style="tom(trilha)">
                                                <img v-if="!semImagem(trilha)" :src="trilha.urlFoto" alt="" @error="onErroImagem(trilha)" />
                                                <svg v-else class="sa-capa-icone" viewBox="0 0 24 24" aria-hidden="true"><path d="M2 4h7a3 3 0 0 1 3 3v13a2 2 0 0 0-2-2H2Z" /><path d="M22 4h-7a3 3 0 0 0-3 3v13a2 2 0 0 1 2-2h8Z" /></svg>
                                                <span v-if="progressoDe(trilha) > 0 && progressoDe(trilha) < 100" class="sa-selo sa-selo--verde sa-selo--direita">{{ Math.round(progressoDe(trilha)) }}%</span>
                                                <span v-else-if="progressoDe(trilha) >= 100" class="sa-selo sa-selo--verde sa-selo--direita">Concluída</span>
                                            </span>
                                            <span class="sa-card-corpo">
                                                <span class="sa-card-titulo">{{ trilha.nmTreinamento }}</span>
                                                <span v-if="trilha.nmAutor" class="sa-card-meta">{{ trilha.nmAutor }}</span>
                                            </span>
                                        </button>
                                    </li>
                                </ul>
                            </section>
                        </main>

                        <footer class="sa-rodape">
                            <div class="sa-rodape-cta">
                                <div class="sa-rodape-texto">
                                    <strong>Aproveite todo o potencial da Soll Academy</strong>
                                    <span>Transforme seu conhecimento e alcance novos patamares na sua carreira.</span>
                                </div>
                                <div class="sa-rodape-acoes">
                                    <router-link :to="{ name: 'SollAcademyTrilhas' }" class="sa-btn sa-btn--branco">Explorar categorias</router-link>
                                    <button type="button" class="sa-btn sa-btn--contorno-claro" @click="abrirManual">Abrir manual</button>
                                </div>
                            </div>
                            <div class="sa-rodape-linha">
                                <span>Soll Academy · SollAi</span>
                                <span>Dúvidas? Fale com nossa equipe</span>
                            </div>
                        </footer>
                    </div>
                </div>
            </div>
        </div>

        <ManualFerramenta ref="manual"
                          class="sa-manual-host"
                          :name="'Manual Academy'"
                          :btnClass="'btn-manual-tool'"
                          :nameBtn="'Manual'"
                          :urlPdf="'/manuais/Manual SollAI Academy.pdf'" />

        <ModalTrilha :trilhaSelecionada="trilhaSelecionada"
                     @fechar="trilhaSelecionada = null" />
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import ModalTrilha from '@/components/SollAcademy/ModalTrilha.vue'
    import axios from 'axios'
    import { urlApi, avisoToast } from '@/config/global'
    import ManualFerramenta from '@/components/Ferramentas/ManualFerramenta'

    export default {
        components: { Header, ModalTrilha, ManualFerramenta },
        name: 'SollAcademy',
        data() {
            return {
                trilhas: [],
                trilhasGerais: [],
                progressos: [], 
                trilhaSelecionada: null,
                categorias: [],
                indiceDestaque: 0,
                carrosselTimer: null,
                carrosselPausado: false,
                direcaoCarrossel: 'avancar',
                termoBusca: '',
                imagensComErro: new Set(),
            }
        },

        computed: {
            trilhasPorCategoria() {
                const g = {};
                const exclude = this.idsEmProgresso;

                for (const t of this.trilhasGerais || []) {
                    if (!t?.idCategoria) continue;
                    if (exclude.has(t.idTreinamento)) continue;

                    if (!g[t.idCategoria]) g[t.idCategoria] = [];
                    g[t.idCategoria].push(t);
                }
                return g;
            },

            categoriasComTrilhas() {
                return (this.categorias || []).filter(
                    c => (this.trilhasPorCategoria[c.idCategoria] || []).length > 0
                )
            },

            progressosUnicos() {
                const best = new Map()
                for (const p of this.progressos || []) {
                    const id = p?.treinamento?.idTreinamento
                    if (!id) continue
                    const atual = best.get(id)
                    if (!atual) {
                        best.set(id, p)
                        continue
                    }
                    const pa = Number(atual.porcentagemCompleta) || 0
                    const pb = Number(p.porcentagemCompleta) || 0
                    if (pb > pa) {
                        best.set(id, p)
                        continue
                    }
                    if (pb === pa) {
                        const da = atual.ultimoProgresso ? new Date(atual.ultimoProgresso).getTime() : -Infinity
                        const db = p.ultimoProgresso ? new Date(p.ultimoProgresso).getTime() : -Infinity
                        if (db > da) best.set(id, p)
                    }
                }
                return Array.from(best.values())
            },

            trilhasRecentes() {
                const isCompleto = (p) => {
                    const pct = Number(p.porcentagemCompleta) || 0;
                    const comp = Number(p.recursosCompletos) || 0;
                    const tot = Number(p.totalRecursos) || 0;
                    return pct >= 100 || (tot > 0 && comp >= tot);
                };

                const top5 = (this.progressosUnicos || [])
                    .filter(p => !!p.ultimoProgresso && !isCompleto(p)) 
                    .sort((a, b) => new Date(b.ultimoProgresso) - new Date(a.ultimoProgresso))
                    .slice(0, 5);

                return top5.map(p => {
                    const base = { ...(p.treinamento || {}) };
                    if (!base.urlFoto) base.urlFoto = 'img-default-curso.png';
                    return { ...base, _progresso: p };
                });
            },

            idsEmProgresso() {
                const ids = new Set();
                for (const t of this.trilhasRecentes || []) {
                    if (t?.idTreinamento) ids.add(t.idTreinamento);
                }
                return ids;
            },

            trilhasDestaque() {
                return this.priorizarComImagem(this.trilhas || []);
            },

            destaquesVisiveis() {
                const lista = this.trilhasDestaque;
                if (!lista.length) return [];
                const qtd = Math.min(4, lista.length);
                return Array.from({ length: qtd }, (_, k) => lista[(this.indiceDestaque + k) % lista.length]);
            },

            destaquePrincipal() {
                return this.destaquesVisiveis[0] || null;
            },

            destaquesSecundarios() {
                return this.destaquesVisiveis.slice(1);
            },

            categoriasVisiveis() {
                return this.categoriasComTrilhas.map(cat => {
                    const todas = (this.trilhasGerais || []).filter(t => t.idCategoria === cat.idCategoria);
                    const visiveis = this.trilhasPorCategoria[cat.idCategoria] || [];
                    return { ...cat, total: todas.length, trilhas: this.priorizarComImagem(visiveis).slice(0, 7) };
                });
            },

            resumo() {
                const lista = this.progressosUnicos || [];
                return {
                    emAndamento: lista.filter(p => !this.progressoCompleto(p) && (Number(p.porcentagemCompleta) > 0 || p.ultimoProgresso)).length,
                    concluidas: lista.filter(p => this.progressoCompleto(p)).length,
                    totalCategorias: (this.categorias || []).length,
                    totalTrilhas: (this.trilhasGerais || []).length,
                };
            },
        },

        methods: {
            load() {
                this.getCategorias();
                this.getTrilhasDestaque();
                this.getTrilhas();
                this.getProgressoTrilhas();
            },

            getCategorias() {
                axios
                    .get(`${urlApi}/SollAcademy/GetCategorias`)
                    .then(res => {
                        if (res.data.success) {
                            this.categorias = res.data.data.rows.map(r => r.item)
                        } else {
                            console.warn('Resposta sem sucesso')
                        }
                    })
                    .catch(err => {
                        console.error('Erro ao carregar categorias:', err)
                        avisoToast('Erro ao carregar categorias!', 'warning')
                    })
            },

            getTrilhasDestaque() {
                axios
                    .get(`${urlApi}/SollAcademy/GetTreinamentos`, { params: { flDestaque: true } })
                    .then(res => {
                        if (res.data.success) {
                            this.trilhas = res.data.data.rows.map(r => {
                                const item = r.item
                                item.urlFoto = item.urlFoto || 'img-default-curso.png'
                                return item
                            })
                        } else {
                            console.warn('Resposta sem sucesso')
                        }
                    })
                    .catch(err => {
                        console.error('Erro ao carregar trilhas:', err)
                        avisoToast('Erro ao carregar trilhas!', 'warning')
                    })
            },

            getTrilhas() {
                axios
                    .get(`${urlApi}/SollAcademy/GetTreinamentos`)
                    .then(res => {
                        if (res.data.success) {
                            this.trilhasGerais = res.data.data.rows.map(r => {
                                const item = r.item
                                item.urlFoto = item.urlFoto || 'img-default-curso.png'
                                return item
                            })
                        } else {
                            console.warn('Resposta sem sucesso')
                        }
                    })
                    .catch(err => {
                        console.error('Erro ao carregar trilhas:', err)
                        avisoToast('Erro ao carregar trilhas!', 'warning')
                    })
            },

            getProgressoTrilhas() {
                axios
                    .get(`${urlApi}/SollAcademy/GetProgressoTreinamentosCliente`)
                    .then(res => {
                        if (res.data.success) {
                            this.progressos = res.data.data
                        } else {
                            console.warn('Resposta sem sucesso')
                        }
                    })
                    .catch(err => {
                        console.error('Erro ao carregar progresso:', err)
                        avisoToast('Erro ao carregar progresso!', 'warning')
                    })
            },

            abrirModal(trilha) {
                this.trilhaSelecionada = trilha
            },

            buscar() {
                const termo = (this.termoBusca || '').trim()
                if (!termo) return
                this.$router.push({ name: 'SollAcademyTrilhas', query: { q: termo } })
            },

            abrirManual() {
                this.$refs.manual?.togleModal()
            },

            iniciarCarrossel() {
                this.pararCarrossel()
                this.carrosselTimer = setInterval(() => {
                    if (!this.carrosselPausado) this.proximoDestaque()
                }, 6000)
            },

            pararCarrossel() {
                if (this.carrosselTimer) clearInterval(this.carrosselTimer)
                this.carrosselTimer = null
            },

            pausarCarrossel() {
                this.carrosselPausado = true
            },

            retomarCarrossel() {
                this.carrosselPausado = false
                this.iniciarCarrossel()
            },

            destaqueAnterior() {
                const n = this.trilhasDestaque.length
                if (!n) return
                this.direcaoCarrossel = 'voltar'
                this.indiceDestaque = (this.indiceDestaque - 1 + n) % n
                this.iniciarCarrossel()
            },

            proximoDestaque() {
                const n = this.trilhasDestaque.length
                if (!n) return
                this.direcaoCarrossel = 'avancar'
                this.indiceDestaque = (this.indiceDestaque + 1) % n
            },

            temImagem(trilha) {
                const url = String(trilha?.urlFoto || '').trim().toLowerCase()
                return !!url && !url.includes('img-default-curso.png')
            },

            priorizarComImagem(lista) {
                const comImagem = []
                const capaPadrao = []
                for (const item of lista || []) {
                    if (this.temImagem(item)) comImagem.push(item)
                    else capaPadrao.push(item)
                }
                return comImagem.concat(capaPadrao)
            },

            proximoDestaqueManual() {
                this.proximoDestaque()
                this.iniciarCarrossel()
            },

            progressoCompleto(p) {
                const pct = Number(p?.porcentagemCompleta) || 0
                const comp = Number(p?.recursosCompletos) || 0
                const tot = Number(p?.totalRecursos) || 0
                return pct >= 100 || (tot > 0 && comp >= tot)
            },

            progressoItem(trilha) {
                if (trilha?._progresso) return trilha._progresso
                return (this.progressosUnicos || []).find(p => p?.treinamento?.idTreinamento === trilha?.idTreinamento) || null
            },

            progressoDe(trilha) {
                return Number(this.progressoItem(trilha)?.porcentagemCompleta) || 0
            },

            metaProgresso(trilha) {
                const p = this.progressoItem(trilha)
                const pct = Math.round(this.progressoDe(trilha))
                const total = Number(p?.totalRecursos) || 0
                const feitos = Number(p?.recursosCompletos) || 0
                const atual = total ? Math.min(total, feitos + 1) : 0
                return atual && total ? `Aula ${atual} de ${total} · ${pct}%` : `${pct}% concluído`
            },

            nomeCategoria(id) {
                const cat = (this.categorias || []).find(c => c.idCategoria === id)
                return cat?.nmCategoria || ''
            },

            plural(quantidade, singular, pluralTxt) {
                return `${quantidade} ${quantidade === 1 ? singular : pluralTxt}`
            },

            tom(trilha) {
                const tons = [
                    ['#e0e7ff', '#4338ca'],
                    ['#dcfce7', '#15803d'],
                    ['#fef3c7', '#b45309'],
                    ['#fce7f3', '#be185d'],
                    ['#e0f2fe', '#0369a1'],
                ]
                const chave = String(trilha?.idTreinamento ?? trilha?.nmTreinamento ?? '')
                let h = 0
                for (const ch of chave) h = (h * 31 + ch.charCodeAt(0)) >>> 0
                const [bg, fg] = tons[h % tons.length]
                return { '--sa-ph-bg': bg, '--sa-ph-fg': fg }
            },

            semImagem(trilha) {
                const url = trilha?.urlFoto
                if (!url) return true
                return this.imagensComErro.has(url)
            },

            onErroImagem(trilha) {
                if (!trilha?.urlFoto) return
                const s = new Set(this.imagensComErro)
                s.add(trilha.urlFoto)
                this.imagensComErro = s
            },
        },

        mounted() {
            this.load()
            this.iniciarCarrossel()
        },

        beforeDestroy() {
            this.pararCarrossel()
        },
    }
</script>

<style scoped>
.sa-manual-host { display: none; }

.sa {
  --sa-azul-escuro: #0b1f4d;
  --sa-primaria: #2563eb;
  --sa-primaria-hover: #1d4ed8;
  --sa-link: #1d4ed8;
  --sa-sucesso: #059669;
  --sa-texto: #0f172a;
  --sa-texto-2: #334155;
  --sa-muted: #64748b;
  --sa-borda: #e2e8f0;
  --sa-fundo: #f4f6fa;
  --sa-superficie: #ffffff;
  --sa-gutter: 40px;

  min-height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--sa-fundo);
  font-family: 'Poppins', system-ui, sans-serif;
  color: var(--sa-texto);
}

.sa svg { width: 18px; height: 18px; flex-shrink: 0; fill: none; stroke: currentColor; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.sa svg.is-fill { fill: currentColor; stroke: none; }
.sa button, .sa a { font: inherit; color: inherit; text-decoration: none; }
.sa-sr { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; }
.sa button:focus-visible, .sa a:focus-visible, .sa input:focus-visible { outline: 2px solid var(--sa-primaria); outline-offset: 2px; }

.sa-btn {
  height: 44px; padding: 0 20px;
  display: inline-flex; align-items: center; justify-content: center; gap: 8px;
  border: 1px solid transparent; border-radius: 10px;
  font-size: 14px; font-weight: 600; white-space: nowrap; cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}
.sa-btn--primario { background: var(--sa-primaria); color: #fff !important; }
.sa-btn--primario:hover { background: var(--sa-primaria-hover); }
.sa-btn--branco { background: #fff; color: var(--sa-azul-escuro) !important; }
.sa-btn--branco:hover { background: #e2e8f0; }
.sa-btn--contorno-claro { background: transparent; border-color: rgba(255, 255, 255, 0.35); color: #fff !important; }
.sa-btn--contorno-claro:hover { background: rgba(255, 255, 255, 0.08); }

.sa-btn-circulo {
  width: 40px; height: 40px; border-radius: 999px;
  display: inline-flex; align-items: center; justify-content: center;
  border: 1px solid var(--sa-borda); background: #fff; color: var(--sa-texto-2) !important; cursor: pointer;
}
.sa-btn-circulo:hover { background: #f8fafc; }

.sa-link {
  display: inline-flex; align-items: center; gap: 4px; min-height: 36px; padding: 0;
  border: 0; background: none; color: var(--sa-link) !important;
  font-size: 14px; font-weight: 600; cursor: pointer;
}
.sa-link svg { width: 16px; height: 16px; }
.sa-link:hover { color: #1e3a8a !important; }

.sa-hero {
  display: grid; grid-template-columns: minmax(0, 1fr) auto; gap: 40px; align-items: center;
  padding: 22px var(--sa-gutter);
  background: var(--sa-azul-escuro); color: #fff;
}
.sa-hero-texto { display: flex; flex-direction: column; gap: 12px; max-width: 880px; }
.sa-hero-titulos { display: flex; flex-direction: column; gap: 4px; }
.sa-hero-titulo {
  margin: 0; font-size: 24px; line-height: 1.3; font-weight: 700;
  color: #fff !important;
  background: none;
  -webkit-text-fill-color: #fff;
}
.sa-hero-sub { margin: 0; font-size: 14px; line-height: 1.5; color: #cbd5e1; }

.sa-busca { display: flex; gap: 8px; }
.sa-busca-campo { position: relative; flex-grow: 1; display: flex; align-items: center; }
.sa-busca-campo svg { position: absolute; left: 14px; color: var(--sa-muted); pointer-events: none; }
.sa-busca-campo input {
  width: 100%; height: 44px; box-sizing: border-box; padding: 0 16px 0 42px;
  border: 0; border-radius: 10px; background: #fff; color: var(--sa-texto);
  font: inherit; font-size: 14px;
}

.sa-hero-atalhos { display: flex; flex-direction: column; align-items: flex-end; gap: 10px; }
.sa-atalhos { display: flex; gap: 12px; }
.sa-atalho {
  min-width: 240px; box-sizing: border-box;
  display: flex; align-items: center; gap: 12px; padding: 12px 16px;
  border: 1px solid rgba(255, 255, 255, 0.14); border-radius: 12px;
  background: rgba(255, 255, 255, 0.08); color: #fff !important;
  text-align: left; cursor: pointer; transition: background 0.15s;
}
.sa-atalho:hover { background: rgba(255, 255, 255, 0.14); }
.sa-atalho-icone {
  width: 36px; height: 36px; flex-shrink: 0; border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  background: rgba(255, 255, 255, 0.16);
}
.sa-atalho-icone--destaque { background: var(--sa-primaria); }
.sa-atalho-texto { display: flex; flex-direction: column; gap: 1px; flex-grow: 1; }
.sa-atalho-texto strong { font-size: 14px; font-weight: 600; }
.sa-atalho-texto span { font-size: 12px; color: #cbd5e1; }
.sa-atalho-seta { width: 16px !important; height: 16px !important; }

.sa-manual {
  display: inline-flex; align-items: center; gap: 6px; min-height: 28px; padding: 0;
  border: 0; background: none; color: #cbd5e1 !important; font-size: 13px; cursor: pointer;
}
.sa-manual svg { width: 15px; height: 15px; }
.sa-manual:hover { color: #fff !important; text-decoration: underline; }

.sa-main { flex-grow: 1; display: flex; flex-direction: column; gap: 24px; padding: 28px var(--sa-gutter) 48px; }
.sa-painel {
  gap: 18px; padding: 20px 24px 24px;
  background: var(--sa-superficie); border: 1px solid var(--sa-borda); border-radius: 16px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}
.sa-painel > .sa-secao-cabecalho { padding-bottom: 14px; border-bottom: 1px solid #eef2f7; }
.sa-painel .sa-h2 { font-size: 18px; }
.sa-secao { display: flex; flex-direction: column; gap: 16px; }
.sa-secao-cabecalho { display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.sa-secao-titulos { display: flex; align-items: baseline; gap: 12px; min-width: 0; }
.sa-h2 { margin: 0; font-size: 20px; font-weight: 700; }
.sa-contagem { font-size: 13px; color: var(--sa-muted); white-space: nowrap; }

.sa-card {
  box-sizing: border-box; width: 100%; height: 100%;
  display: flex; flex-direction: column; padding: 0;
  background: var(--sa-superficie); border: 1px solid var(--sa-borda); border-radius: 14px; overflow: hidden;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  text-align: left; color: var(--sa-texto) !important; cursor: pointer;
  transition: transform 0.15s, box-shadow 0.15s, border-color 0.15s;
}
.sa-card:hover { transform: translateY(-2px); border-color: #c7d2fe; box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08); }

.sa-capa {
  position: relative; aspect-ratio: 16 / 9; flex-shrink: 0; overflow: hidden;
  display: flex; align-items: center; justify-content: center;
  background: var(--sa-ph-bg, #e2e8f0); color: var(--sa-ph-fg, #475569);
}
.sa-capa img { position: absolute; inset: 0; z-index: 1; width: 100%; height: 100%; object-fit: cover; }
.sa-capa-icone { width: 32px !important; height: 32px !important; stroke-width: 1.6 !important; }

.sa-card-corpo { flex-grow: 1; display: flex; flex-direction: column; gap: 4px; padding: 14px 16px 16px; min-width: 0; }
.sa-card-titulo {
  font-size: 14px; font-weight: 600; line-height: 1.4;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
}
.sa-card-desc {
  font-size: 13px; line-height: 1.5; color: var(--sa-muted);
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
}
.sa-card-meta { font-size: 12px; color: var(--sa-muted); }

.sa-selo {
  position: absolute; left: 12px; top: 12px;
  font-size: 11px; font-weight: 600; letter-spacing: 0.04em;
  padding: 3px 9px; border-radius: 999px;
}
.sa-selo--azul { position: static; align-self: flex-start; background: var(--sa-primaria); color: #fff; letter-spacing: 0.08em; padding: 4px 10px; }
.sa-selo--claro { background: rgba(255, 255, 255, 0.92); color: #1e3a8a; }
.sa-selo--verde { background: var(--sa-sucesso); color: #fff; letter-spacing: 0; }
.sa-selo--direita { left: auto; right: 8px; top: 8px; }

.sa-carrossel-controles { position: absolute; right: 20px; bottom: 26px; z-index: 2; display: flex; align-items: center; gap: 10px; }
.sa-pontos { display: flex; gap: 6px; margin-right: 4px; }
.sa-ponto { width: 6px; height: 6px; border-radius: 999px; background: rgba(255, 255, 255, 0.4); transition: width 0.2s, background 0.2s; }
.sa-ponto.is-ativo { width: 20px; background: #fff; }
.sa-carrossel-controles .sa-btn-circulo { border-color: rgba(255, 255, 255, 0.3); background: rgba(15, 23, 42, 0.45); color: #fff !important; }
.sa-carrossel-controles .sa-btn-circulo:hover { background: rgba(15, 23, 42, 0.7); }

.sa-destaques { display: grid; grid-template-columns: 2fr repeat(3, minmax(0, 1fr)); gap: 20px; height: 360px; }
.sa-destaques--1 { grid-template-columns: 1fr; }
.sa-destaques--2 { grid-template-columns: 2fr 1fr; }
.sa-destaques--3 { grid-template-columns: 2fr 1fr 1fr; }

.sa-destaque-principal { position: relative; overflow: hidden; border-radius: 16px; background: var(--sa-ph-fg, #1e293b); }
.sa-destaque-link {
  position: absolute; inset: 0; padding: 0; border: 0; background: none;
  text-align: left; cursor: pointer; color: #fff !important;
}
.sa-destaque-link img { position: absolute; inset: 0; z-index: 0; width: 100%; height: 100%; object-fit: cover; transition: transform 0.4s; }
.sa-slide-enter-active, .sa-slide-leave-active,
.sa-slide-voltar-enter-active, .sa-slide-voltar-leave-active { transition: opacity 0.5s ease, transform 0.5s ease; }
.sa-slide-enter { opacity: 0; transform: translateX(28px); }
.sa-slide-leave-to { opacity: 0; transform: translateX(-28px); }
.sa-slide-voltar-enter { opacity: 0; transform: translateX(-28px); }
.sa-slide-voltar-leave-to { opacity: 0; transform: translateX(28px); }
.sa-destaque-sec { animation: sa-card-in 0.45s ease; }
.is-voltar .sa-destaque-sec { animation-name: sa-card-in-voltar; }
@keyframes sa-card-in {
  from { opacity: 0; transform: translateX(16px); }
  to { opacity: 1; transform: none; }
}
@keyframes sa-card-in-voltar {
  from { opacity: 0; transform: translateX(-16px); }
  to { opacity: 1; transform: none; }
}
.sa-destaque-link:hover img { transform: scale(1.03); }
.sa-destaque-scrim {
  position: absolute; inset: 0;
  background: linear-gradient(to top, rgba(2, 6, 23, 0.92) 0%, rgba(2, 6, 23, 0.55) 45%, rgba(2, 6, 23, 0.05) 100%);
}
.sa-destaque-conteudo { position: absolute; left: 28px; right: 240px; bottom: 26px; display: flex; flex-direction: column; gap: 10px; }
.sa-destaque-titulo { font-size: 26px; line-height: 1.25; font-weight: 700; }
.sa-destaque-desc {
  max-width: 560px; font-size: 14px; line-height: 1.55; color: #cbd5e1;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
}
.sa-destaque-rodape { display: flex; align-items: center; gap: 16px; margin-top: 6px; }
.sa-destaque-cta {
  height: 40px; padding: 0 18px; border-radius: 10px;
  display: inline-flex; align-items: center; gap: 8px;
  background: #fff; color: var(--sa-texto); font-size: 14px; font-weight: 600;
}
.sa-destaque-cta svg { width: 14px; height: 14px; }
.sa-destaque-sec .sa-card-meta { margin-top: auto; }

.sa-continue { list-style: none; margin: 0; padding: 0; display: grid; grid-template-columns: repeat(5, minmax(0, 1fr)); gap: 16px; }
.sa-continue-card { flex-direction: row; gap: 14px; padding: 12px; background: #f8fafc; border-radius: 12px; }
.sa-continue-thumb {
  position: relative; width: 120px; aspect-ratio: 16 / 9; flex-shrink: 0; overflow: hidden; border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  background: var(--sa-ph-bg, #e2e8f0);
}
.sa-continue-thumb img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }
.sa-play {
  position: relative; width: 30px; height: 30px; border-radius: 999px;
  display: flex; align-items: center; justify-content: center;
  background: rgba(15, 23, 42, 0.7); color: #fff;
}
.sa-play svg { width: 12px; height: 12px; }
.sa-continue-texto { flex-grow: 1; min-width: 0; display: flex; flex-direction: column; gap: 6px; }
.sa-barra { margin-top: auto; height: 5px; border-radius: 999px; overflow: hidden; background: var(--sa-borda); }
.sa-barra-fill { display: block; height: 100%; background: var(--sa-sucesso); border-radius: 999px; }

.sa-trilhas {
  --sa-colunas: 7;
  list-style: none; margin: 0; padding: 0;
  display: grid; grid-template-columns: repeat(var(--sa-colunas), minmax(0, 1fr)); gap: 16px;
}
.sa-trilhas > li { display: flex; }
.sa-trilha { border-radius: 12px; box-shadow: 0 2px 6px rgba(15, 23, 42, 0.06); }

.sa-rodape {
  display: flex; flex-direction: column; gap: 24px;
  padding: 32px var(--sa-gutter) 24px;
  background: var(--sa-azul-escuro); color: #fff;
}
.sa-rodape-cta { display: flex; align-items: center; justify-content: space-between; gap: 32px; }
.sa-rodape-texto { display: flex; flex-direction: column; gap: 6px; }
.sa-rodape-texto strong { font-size: 20px; font-weight: 700; }
.sa-rodape-texto span { font-size: 14px; color: #cbd5e1; }
.sa-rodape-acoes { display: flex; gap: 10px; flex-shrink: 0; }
.sa-rodape-linha {
  display: flex; justify-content: space-between; gap: 16px;
  padding-top: 20px; border-top: 1px solid rgba(255, 255, 255, 0.14);
  font-size: 12px; color: #94a3b8;
}

@media (max-width: 1700px) {
  .sa-trilhas { --sa-colunas: 6; }
  .sa-trilhas > li:nth-child(n + 7) { display: none; }
  .sa-continue { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .sa-continue > li:nth-child(n + 5) { display: none; }
}
@media (max-width: 1440px) {
  .sa { --sa-gutter: 32px; }
  .sa-trilhas { --sa-colunas: 5; }
  .sa-trilhas > li:nth-child(n + 6) { display: none; }
  .sa-destaques { grid-template-columns: 2fr 1fr 1fr; }
  .sa-destaques > :nth-child(n + 4) { display: none; }
  .sa-continue { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .sa-continue > li:nth-child(n + 4) { display: none; }
}
@media (max-width: 1200px) {
  .sa-hero { grid-template-columns: minmax(0, 1fr); }
  .sa-hero-atalhos { align-items: flex-start; }
  .sa-trilhas { --sa-colunas: 4; }
  .sa-trilhas > li:nth-child(n + 5) { display: none; }
}
@media (max-width: 900px) {
  .sa { --sa-gutter: 20px; }
  .sa-atalhos { flex-direction: column; width: 100%; }
  .sa-atalho { min-width: 0; width: 100%; }
  .sa-destaques { grid-template-columns: minmax(0, 1fr); height: auto; }
  .sa-destaque-principal { height: 320px; }
  .sa-destaque-conteudo { right: 28px; bottom: 80px; }
  .sa-painel { padding: 16px; }
  .sa-destaques > :nth-child(n + 2) { display: none; }
  .sa-continue { grid-template-columns: minmax(0, 1fr); }
  .sa-continue > li:nth-child(n + 3) { display: none; }
  .sa-trilhas { display: flex; overflow-x: auto; scroll-snap-type: x mandatory; padding-bottom: 4px; }
  .sa-trilhas > li { display: flex !important; flex: 0 0 220px; scroll-snap-align: start; }
  .sa-rodape-cta { flex-direction: column; align-items: flex-start; }
}

[data-bs-theme="dark"] .sa {
  --sa-texto: #f1f5f9;
  --sa-texto-2: #cbd5e1;
  --sa-muted: #94a3b8;
  --sa-borda: rgba(148, 163, 184, 0.22);
  --sa-fundo: #0b1120;
  --sa-superficie: #1e293b;
  --sa-link: #93c5fd;
}
[data-bs-theme="dark"] .sa-painel > .sa-secao-cabecalho { border-bottom-color: rgba(148, 163, 184, 0.14); }
[data-bs-theme="dark"] .sa-continue-card { background: #0f172a; }
[data-bs-theme="dark"] .sa-busca-campo input,
[data-bs-theme="dark"] .sa-btn-circulo,
[data-bs-theme="dark"] .sa-destaque-cta,
[data-bs-theme="dark"] .sa-btn--branco { color: #0f172a !important; }
</style>
